"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistoryOptions = void 0;
const useToolsOptionsSelector_1 = require("./useToolsOptionsSelector");
function useHistoryOptions() {
    return {
        isUndoActive: (0, useToolsOptionsSelector_1.useToolsOptionsSelector)(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.isUndoActive) !== null && _a !== void 0 ? _a : false; }),
        isRedoActive: (0, useToolsOptionsSelector_1.useToolsOptionsSelector)(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.isRedoActive) !== null && _a !== void 0 ? _a : false; }),
        isClearActive: (0, useToolsOptionsSelector_1.useToolsOptionsSelector)(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.isClearActive) !== null && _a !== void 0 ? _a : false; }),
    };
}
exports.useHistoryOptions = useHistoryOptions;
